"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var React = _interopRequireWildcard(require("react"));
var _styles = require("../styles");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var Arrow = function Arrow(_ref) {
  var className = _ref.className,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 32 : _ref$size,
    _ref$animation = _ref.animation,
    animation = _ref$animation === void 0 ? '' : _ref$animation;
  return /*#__PURE__*/React.createElement(_styles.Svg, {
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    className: "".concat(className, " ").concat(animation),
    width: size,
    height: size,
    viewBox: "0 0 50 50"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45.309 17.896c-3.014 1.834-6.58 2.004-10.064 2.17-.808.038-1.497.66-1.497 1.497 0 .781.686 1.536 1.497 1.498 1.59-.076 3.206-.171 4.797-.388-4.454 3.316-9.417 5.909-15.053 6.48-6.88.699-14.454-.959-19.93-5.346-1.491-1.193-3.624.913-2.119 2.118 6.1 4.886 14.317 6.993 22.049 6.224 6.796-.677 12.634-3.814 17.893-7.896l-1.436 4.512c-.245.771.288 1.634 1.046 1.843.808.222 1.596-.273 1.842-1.046l3.175-9.974c.397-1.248-1.106-2.357-2.2-1.692z"
  }));
};
var _default = exports["default"] = Arrow;